export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];

export const YEARS = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
